import { CandidateJobMatchCard } from '../../../models/candidateJobMatchCard';
var SendAssessmentController = /** @class */ (function () {
    /*@ngInject*/
    function SendAssessmentController($rootScope, $uibModal, $timeout, $filter, moment, dateTimeUtilityService, jobMatchService, jobService, assessmentService, planService, candidateService, companyService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.moment = moment;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.assessmentService = assessmentService;
        this.planService = planService;
        this.candidateService = candidateService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    SendAssessmentController.prototype.$onInit = function () {
        var _this = this;
        //variables
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.assessmentData = {
            jobMatchId: null,
            companyId: this.companyId,
            notes: '',
            externalNote: '',
            startDateTime: null,
            endDateTime: null,
            accessTime: null,
            reminder: 2,
            timeToComplete: null,
            //timeZoneId: null
            timeZoneName: null
        };
        this.externalNotesAction = {};
        this.sendAssessmentLabel = '';
        this.assessmentName = '';
        this.candidateJobMatch = {};
        this.accessTimePreferences = {};
        this.remindAfterDays = [];
        this.jobMatchDetailsArray = [];
        this.jobMatchesThatCanBeSentAssessment = [];
        this.jobMatchesThatCannotBeSentAssessment = [];
        this.sendAssessmentLicensePreferenceEnum = null;
        this.assessmentDetails = null;
        this.previousStateDateTime = null;
        this.assessmentsLeft;
        this.defaultReminderInterval = 0;
        //flags
        this.loadingFlag = true;
        this.savingFlag = false;
        this.isTrialPlanActive = false;
        this.isCompanyOnSoftHold = false;
        this.loadingAccessTimeOptionsFlag = false;
        this.showAccessTimeOptionsFlag = false;
        this.reminderErrorFlag = false;
        this.multipleJobMatchesFlag = false;
        this.loadingMultipleJobMatchesDataFlag = false;
        this.isStaffingCompany = false;
        this.isReminderEnabled = false;
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.getCompanyState(function () {
            _this.getCompanyPlanDetails(function () {
                _this._initializeAssessmentDetails();
            });
        });
    };
    SendAssessmentController.prototype._initializeAssessmentDetails = function () {
        var _this = this;
        this.userId = this.$rootScope.userDetails.id;
        if (!_.isUndefined(this.jobMatchDetailsArrayString)) {
            this.multipleJobMatchesFlag = true;
            this.jobMatchDetailsArray = JSON.parse(this.jobMatchDetailsArrayString);
            this.jobMatchId = this.jobMatchDetailsArray[0].jobMatchId;
            this.candidateId = this.jobMatchDetailsArray[0].candidateId;
        }
        else {
            this.multipleJobMatchesFlag = false;
            var tempObject = {};
            tempObject.jobMatchId = this.jobMatchId;
            tempObject.candidateId = this.candidateId;
            this.jobMatchDetailsArray.push(tempObject);
        }
        if (this.multipleJobMatchesFlag) {
            this.loadingMultipleJobMatchesDataFlag = true;
            // initialize for each of the job matches
            angular.forEach(this.jobMatchDetailsArray, function (val, key) {
                val.loadingFlag = true;
                val.sendErrorType = null;
                val.sendErrorMessage = null;
                val.jobMatchData = {};
            });
            // get details for each of the job matches to be shown
            angular.forEach(this.jobMatchDetailsArray, function (val, key) {
                _this.getCandidateJobMatchCardInfo(val.jobMatchId, function () {
                    val.jobMatchData = angular.copy(_this.candidateJobMatch);
                    val.loadingFlag = false;
                    if (_this.assessmentType == "Technical" && (val.jobMatchData.jobMatchCurrentState == 'In Tech Assessment' || val.jobMatchData.jobMatchCurrentState == 'Tech Assessment Canceled')) {
                        var sendActionInfo = _.find(val.jobMatchData.availableActions, { actionType: "SEND_TECHNICAL_ASSESSMENT" });
                        if (sendActionInfo == undefined) {
                            val.sendErrorType = 'actionNotAllowed';
                            var message = "";
                            message = val.jobMatchData.joinedInOtherJob ? 'Candidate is already in joined status in another requisition.' : (val.jobMatchData.filledInOtherJob ? 'Candidate is already in filled status in another requisition.' : '');
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + message;
                            _this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                        else if (sendActionInfo.allowed) {
                            val.message = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "')";
                            _this.jobMatchesThatCanBeSentAssessment.push(val);
                        }
                        else {
                            val.sendErrorType = 'actionNotAllowed';
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + sendActionInfo.message;
                            _this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                    }
                    else if (_this.assessmentType == "Technical" && _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_TECHNICAL_ASSESSMENT" }) !== undefined) {
                        var resendActionInfo = _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_TECHNICAL_ASSESSMENT" });
                        if (resendActionInfo.allowed) {
                            _this._setResendAssessmentInfo(val);
                            _this.jobMatchesThatCanBeSentAssessment.push(val);
                        }
                        else {
                            val.sendErrorType = 'actionNotAllowed';
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + resendActionInfo.message;
                            _this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                    }
                    else if (_this.assessmentType == "Value" && (val.jobMatchData.jobMatchCurrentState == 'In Value Assessment' || val.jobMatchData.jobMatchCurrentState == 'Value Assessment Canceled')) {
                        var sendActionInfo = _.find(val.jobMatchData.availableActions, { actionType: "SEND_VALUE_ASSESSMENT" });
                        if (sendActionInfo == undefined) {
                            val.sendErrorType = 'actionNotAllowed';
                            var message = "";
                            message = val.jobMatchData.joinedInOtherJob ? 'Candidate is already in joined status in another requisition' : (val.jobMatchData.filledInOtherJob ? 'Candidate is already in filled status in another requisition.' : '');
                            val.sendErrorMessage = " (Current status: '" + message + "')";
                            _this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                        else if (sendActionInfo.allowed) {
                            val.message = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "')";
                            _this.jobMatchesThatCanBeSentAssessment.push(val);
                        }
                        else {
                            val.sendErrorType = 'actionNotAllowed';
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + sendActionInfo.message;
                            _this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                    }
                    else if (_this.assessmentType == "Value" && _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_VALUE_ASSESSMENT" }) !== undefined) {
                        var resendActionInfo = _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_VALUE_ASSESSMENT" });
                        if (resendActionInfo.allowed) {
                            _this._setResendAssessmentInfo(val);
                            _this.jobMatchesThatCanBeSentAssessment.push(val);
                        }
                        else {
                            val.sendErrorType = 'actionNotAllowed';
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + resendActionInfo.message;
                            _this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                    }
                    else {
                        val.sendErrorType = 'wrongState';
                        val.sendErrorMessage = " is not in a valid status (Current status: '" + val.jobMatchData.jobMatchCurrentState + "').";
                        _this.jobMatchesThatCannotBeSentAssessment.push(val);
                    }
                    if ((_this.jobMatchesThatCanBeSentAssessment.length + _this.jobMatchesThatCannotBeSentAssessment.length) == _this.jobMatchDetailsArray.length) {
                        _this.loadingMultipleJobMatchesDataFlag = false;
                    }
                    if (!_this.loadingMultipleJobMatchesDataFlag && !_this.loadingAccessTimeOptionsFlag) {
                        _this.loadingFlag = false;
                    }
                }, function (error) {
                    val.loadingFlag = false;
                    _this.loadingMultipleJobMatchesDataFlag = false;
                });
            });
        }
        this.assessmentData.jobMatchId = this.jobMatchId;
        this.loadingAccessTimeOptionsFlag = true;
        for (var i = 0; i <= 31; i++) {
            this.remindAfterDays.push({
                id: i,
                text: '' + i
            });
        }
        if (_.isNull(this.assessmentSendMode)) {
            this.assessmentSendMode = 'send';
        }
        switch (this.assessmentType) {
            case 'Technical':
                this.sendAssessmentLabel = 'Technical Assessment';
                this.sendAssessmentLicensePreferenceEnum = 'TECH_ASSESSMENT';
                break;
            case 'Value':
                this.sendAssessmentLabel = 'Value Assessment';
                this.sendAssessmentLicensePreferenceEnum = 'VALUE_ASSESSMENT';
                break;
        }
        this.assessmentData.notes = 'Sending ' + this.sendAssessmentLabel;
        if (this.assessmentSendMode == 'resend') {
            this.assessmentData.notes = 'Resending ' + this.sendAssessmentLabel;
        }
        if (this.notes !== "") {
            this.assessmentData.notes = this.notes;
        }
        this.candidateJobMatch = new CandidateJobMatchCard();
        this.getCandidateJobMatchCardInfo(this.jobMatchId, function () {
            if (_this.isTrialPlanActive || _this.isCompanyOnSoftHold) {
                _this.getAvailableAssessments();
            }
            if (_this.assessmentSendMode == 'resend') {
                var assessmentDetailsObject = {};
                assessmentDetailsObject.jobMatchId = _this.jobMatchId;
                assessmentDetailsObject.assessmentType = _this.assessmentType;
                _this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, function (data) {
                    _this.assessmentDetails = data;
                    _this.assessmentDetails.isSendAssessmentFailed = _this.candidateJobMatch.jobMatchCurrentState.includes("Failed");
                    if (!_.isNull(_this.assessmentDetails.expiredDateTime)) {
                        _this.assessmentDetails.expiredDateTime = new Date(_this.assessmentDetails.expiredDateTime);
                    }
                    if (!_.isNull(_this.assessmentDetails.cancelledDateTime)) {
                        _this.assessmentDetails.cancelledDateTime = new Date(_this.assessmentDetails.cancelledDateTime);
                    }
                    if (!_.isNull(_this.assessmentDetails.completedDateTime)) {
                        _this.assessmentDetails.completedDateTime = new Date(_this.assessmentDetails.completedDateTime);
                    }
                    if (!_.isNull(_this.assessmentDetails.sentDateTime)) {
                        _this.assessmentDetails.sentDateTime = new Date(_this.assessmentDetails.sentDateTime);
                    }
                    if (!_.isNull(_this.assessmentDetails.suspendedDateTime)) {
                        _this.assessmentDetails.suspendedDateTime = new Date(_this.assessmentDetails.suspendedDateTime);
                    }
                    if (!_.isNull(_this.assessmentDetails.terminatedDateTime)) {
                        _this.assessmentDetails.terminatedDateTime = new Date(_this.assessmentDetails.terminatedDateTime);
                    }
                    if (!_.isNull(_this.assessmentDetails.testLeftDateTime)) {
                        _this.assessmentDetails.testLeftDateTime = new Date(_this.assessmentDetails.testLeftDateTime);
                    }
                    if (_this.assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(_this.assessmentDetails.expiredDateTime)) {
                        _this.previousStateDateTime = _this.assessmentDetails.expiredDateTime;
                    }
                    else if (_this.assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(_this.assessmentDetails.suspendedDateTime)) {
                        _this.previousStateDateTime = _this.assessmentDetails.suspendedDateTime;
                    }
                    else if (_this.assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(_this.assessmentDetails.terminatedDateTime)) {
                        _this.previousStateDateTime = _this.assessmentDetails.terminatedDateTime;
                    }
                    else if (_this.assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(_this.assessmentDetails.testLeftDateTime)) {
                        _this.previousStateDateTime = _this.assessmentDetails.testLeftDateTime;
                    }
                    else if (_this.assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(_this.assessmentDetails.completedDateTime)) {
                        _this.previousStateDateTime = _this.assessmentDetails.completedDateTime;
                    }
                    else if (_this.assessmentDetails.isSendAssessmentFailed && !_.isNull(_this.assessmentDetails.sentDateTime)) {
                        _this.previousStateDateTime = _this.assessmentDetails.sentDateTime;
                    }
                    else {
                        _this.previousStateDateTime = '';
                    }
                    _this.assessmentDetails.sendAssessmentsCount = _this.assessmentDetails.sendAssessmentsCount + 1;
                    _this.assessmentDetails = _this._setSentAssessmentsPostfix(_this.assessmentDetails);
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
            _this.getAccessTimePreferences(function () {
                if (_.isNull(_this.accessTimePreferences.timeToComplete)) {
                    // default time to complete, if it is null
                    _this.accessTimePreferences.timeToComplete = 2;
                }
                if (_.isNull(_this.accessTimePreferences.reminderInterval)) {
                    // default reminder interval, if it is null
                    _this.accessTimePreferences.reminderInterval = 2;
                }
                _this.assessmentData.reminder = _this.accessTimePreferences.reminderInterval;
                _this.defaultReminderInterval = _this.assessmentData.reminder;
                if (_this.assessmentData.reminder > 0) {
                    _this.isReminderEnabled = true;
                }
                else {
                    _this.defaultReminderInterval = 2;
                }
                // initialize all access time options to be false
                _this.accessTimePreferences.anyTime = false;
                _this.accessTimePreferences.timeBound = false;
                _this.accessTimePreferences.slotWise = false;
                // TODO: remove jQuery and use data binding to set the default value.
                $('#reminderInDays').val(_this.assessmentData.reminder);
                var accessTimeOptionsToShowCount = 0;
                angular.forEach(_this.accessTimePreferences.accessTimeDtos, function (val, key) {
                    if (val.accessTimeLabel == 'Any Time') {
                        if (val.accessTimeEnabled && val.accessTimeValue) {
                            _this.accessTimePreferences.anyTime = true;
                            accessTimeOptionsToShowCount++;
                        }
                    }
                    else if (val.accessTimeLabel == 'Time Bound') {
                        if (val.accessTimeEnabled && val.accessTimeValue) {
                            _this.accessTimePreferences.timeBound = true;
                            accessTimeOptionsToShowCount++;
                        }
                    }
                    else if (val.accessTimeLabel == 'Slot Wise') {
                        if (val.accessTimeEnabled && val.accessTimeValue) {
                            _this.accessTimePreferences.slotWise = true;
                            accessTimeOptionsToShowCount++;
                        }
                    }
                });
                if (accessTimeOptionsToShowCount == 0) {
                    _this.showAccessTimeOptionsFlag = false;
                    // default to any time if all the options are sent as 'false'
                    _this.assessmentData.accessTime = 'anyTime';
                }
                else if (accessTimeOptionsToShowCount == 1) {
                    _this.showAccessTimeOptionsFlag = false;
                    if (_this.accessTimePreferences.anyTime) {
                        _this.assessmentData.accessTime = 'anyTime';
                    }
                    else if (_this.accessTimePreferences.timeBound) {
                        _this.assessmentData.accessTime = 'timeBound';
                        _this._initializeDateAndTimePickersForTimeBound();
                    }
                    else if (_this.accessTimePreferences.slotWise) {
                        _this.assessmentData.accessTime = 'slotWise';
                        _this._initializeDateAndTimePickersForSlotWise();
                    }
                }
                else if (accessTimeOptionsToShowCount > 1) {
                    _this.showAccessTimeOptionsFlag = true;
                    if (_this.accessTimePreferences.anyTime) {
                        _this.assessmentData.accessTime = 'anyTime';
                    }
                    if (_this.accessTimePreferences.timeBound) {
                        _this._initializeDateAndTimePickersForTimeBound();
                    }
                    if (_this.accessTimePreferences.slotWise) {
                        _this._initializeDateAndTimePickersForSlotWise();
                    }
                    // default to the first available option
                    if (_this.accessTimePreferences.anyTime) {
                        _this.assessmentData.accessTime = 'anyTime';
                    }
                    else {
                        // time bound should be available since anyTime is not available
                        _this.assessmentData.accessTime = 'timeBound';
                    }
                }
                _this.loadingAccessTimeOptionsFlag = false;
                if (!_this.loadingAccessTimeOptionsFlag && !_this.loadingMultipleJobMatchesDataFlag) {
                    _this.loadingFlag = false;
                }
                _this.$timeout(function () {
                    _this.reminderChanged();
                }, 500);
            });
        });
    };
    SendAssessmentController.prototype._setResendAssessmentInfo = function (jobMatch) {
        var _this = this;
        var assessmentDetailsObject = {};
        assessmentDetailsObject.jobMatchId = jobMatch.jobMatchId;
        assessmentDetailsObject.assessmentType = this.assessmentType;
        this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, function (data) {
            jobMatch.assessmentDetails = data;
            if (!_.isNull(jobMatch.assessmentDetails.expiredDateTime)) {
                jobMatch.assessmentDetails.expiredDateTime = new Date(jobMatch.assessmentDetails.expiredDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.cancelledDateTime)) {
                jobMatch.assessmentDetails.cancelledDateTime = new Date(jobMatch.assessmentDetails.cancelledDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.completedDateTime)) {
                jobMatch.assessmentDetails.completedDateTime = new Date(jobMatch.assessmentDetails.completedDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.sentDateTime)) {
                jobMatch.assessmentDetails.sentDateTime = new Date(jobMatch.assessmentDetails.sentDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.suspendedDateTime)) {
                jobMatch.assessmentDetails.suspendedDateTime = new Date(jobMatch.assessmentDetails.suspendedDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.terminatedDateTime)) {
                jobMatch.assessmentDetails.terminatedDateTime = new Date(jobMatch.assessmentDetails.terminatedDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.testLeftDateTime)) {
                jobMatch.assessmentDetails.testLeftDateTime = new Date(jobMatch.assessmentDetails.testLeftDateTime);
            }
            if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(jobMatch.assessmentDetails.expiredDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.expiredDateTime;
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(jobMatch.assessmentDetails.suspendedDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.suspendedDateTime;
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(jobMatch.assessmentDetails.terminatedDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.terminatedDateTime;
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(jobMatch.assessmentDetails.testLeftDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.testLeftDateTime;
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(jobMatch.assessmentDetails.completedDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.completedDateTime;
            }
            else if (jobMatch.jobMatchData.jobMatchCurrentState.includes('Failed') && !_.isNull(jobMatch.assessmentDetails.sentDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.sentDateTime;
            }
            else {
                jobMatch.previousStateDateTime = '';
            }
            jobMatch.assessmentDetails.sendAssessmentsCount = jobMatch.assessmentDetails.sendAssessmentsCount + 1;
            jobMatch.assessmentDetails = _this._setSentAssessmentsPostfix(jobMatch.assessmentDetails);
            jobMatch.message = "";
            var htmlMessage = "Resending Assessment ";
            if (jobMatch.assessmentDetails.assessmentLinkStatus == "Cancelled") {
                htmlMessage = htmlMessage + "as it was previously Canceled on '" + _this.$filter('fourdotfiveTimeStampFormat')(jobMatch.assessmentDetails.cancelledDateTime) + "'";
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Expired' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Suspended' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Test Left' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Terminated') {
                htmlMessage = htmlMessage + "as it is in " + jobMatch.assessmentDetails.assessmentLinkStatus + " status. The Assessment was sent on '" + _this.$filter('fourdotfiveTimeStampFormat')(jobMatch.assessmentDetails.sentDateTime) + "' and  '" + jobMatch.assessmentDetails.assessmentLinkStatus + "' on '" + _this.$filter('fourdotfiveTimeStampFormat')(jobMatch.previousStateDateTime) + "'";
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Complete') {
                htmlMessage = htmlMessage + " as it was previously Completed. The Assessment was sent on '" + _this.$filter('fourdotfiveTimeStampFormat')(jobMatch.assessmentDetails.sentDateTime) + "' and was Completed on '" + _this.$filter('fourdotfiveTimeStampFormat')(jobMatch.previousStateDateTime) + "'";
            }
            else if (jobMatch.assessmentDetails.isSendAssessmentFailed) {
                htmlMessage = htmlMessage + "as the previous attempt to send failed on '" + _this.$filter('fourdotfiveTimeStampFormat')(jobMatch.assessmentDetails.sentDateTime) + "'";
            }
            jobMatch.message = jobMatch.message + htmlMessage;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SendAssessmentController.prototype._setSentAssessmentsPostfix = function (assessmentDetails) {
        assessmentDetails.sendAssessmentsCountDisplayValue = "";
        if (assessmentDetails.sendAssessmentsCount == 1) {
            assessmentDetails.sendAssessmentsCountDisplayValue = "1st";
        }
        else if (assessmentDetails.sendAssessmentsCount == 2) {
            assessmentDetails.sendAssessmentsCountDisplayValue = "2nd";
        }
        else if (assessmentDetails.sendAssessmentsCount == 3) {
            assessmentDetails.sendAssessmentsCountDisplayValue = "3rd";
        }
        else {
            assessmentDetails.sendAssessmentsCountDisplayValue = assessmentDetails.sendAssessmentsCount + "th";
        }
        return assessmentDetails;
    };
    SendAssessmentController.prototype.getCompanyState = function (successCallback) {
        var _this = this;
        if (this.isStaffingCompany && this.isSharedRequisition) {
            this.companyService.getCompanyDetails(this.corporateId, function (data) {
                _this.isCompanyOnSoftHold = data.companyState == 'SoftHold' ? true : false;
                successCallback();
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.isCompanyOnSoftHold = this.$rootScope.userDetails.company.companyState == 'SoftHold' ? true : false;
            successCallback();
        }
    };
    SendAssessmentController.prototype.getCompanyPlanDetails = function (successCallback) {
        var _this = this;
        var getPlanOfCompanyId = this.companyId;
        if (this.isStaffingCompany && this.isSharedRequisition) {
            getPlanOfCompanyId = this.corporateId;
        }
        this.planService.getCompanyPlanDetails(getPlanOfCompanyId, function (data) {
            if (!_.isNull(data)) {
                _this.isTrialPlanActive = data.plan == "Trial" ? true : false;
            }
            successCallback();
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SendAssessmentController.prototype.getAvailableAssessments = function () {
        var _this = this;
        this.planService.getAvailableTechAssessmentsCount(this.companyId, this.candidateJobMatch.jobMatchJobId, function (data) {
            _this.assessmentsLeft = data["techAssessmentsLeft"];
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SendAssessmentController.prototype.sendAssessment = function () {
        var _this = this;
        if (!this.sendAssessmentForm.$invalid && !this.reminderErrorFlag) {
            this.savingFlag = true;
            var assessmentDataForSave = angular.copy(this.assessmentData);
            if (this.assessmentData.accessTime == 'anyTime') {
                assessmentDataForSave.startDateTime = null;
                assessmentDataForSave.endDateTime = null;
            }
            else if (this.assessmentData.accessTime == 'timeBound') {
                assessmentDataForSave.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime));
                assessmentDataForSave.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime));
            }
            else if (this.assessmentData.accessTime == 'slotWise') {
                assessmentDataForSave.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.slotWiseStartDate + ' ' + this.slotWiseStartTime));
                assessmentDataForSave.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.slotWiseEndDate + ' ' + this.slotWiseEndTime));
            }
            assessmentDataForSave.sentDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date());
            if (this.assessmentSendMode == 'send') {
                if (this.multipleJobMatchesFlag) {
                    assessmentDataForSave.jobMatchIds = this.jobMatchesThatCanBeSentAssessment.map(function (jobMatch) {
                        return jobMatch.jobMatchId;
                    });
                    delete assessmentDataForSave.jobMatchId;
                    this.candidateService.sendAssessments(this.assessmentType, assessmentDataForSave, function (sendResultsArray) {
                        _this.savingFlag = false;
                        var sendAssessmentResultsModal = _this.$uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            backdrop: 'static',
                            keyboard: false,
                            windowTopClass: 'four-dot-five-modal-medium',
                            component: 'sendAssessmentResultsModal',
                            resolve: {
                                jobMatchDetailsArray: function () {
                                    return _this.jobMatchesThatCanBeSentAssessment;
                                },
                                sendResultsArray: function () {
                                    return sendResultsArray;
                                }
                            }
                        });
                        sendAssessmentResultsModal.result.then(function (callbackObject) {
                            if (callbackObject.callbackType == 'close' && !_.isUndefined(_this.saveCallback)) {
                                _this.saveCallback();
                            }
                        }, function (dismiss) {
                            //do nothing
                        });
                    }, function (error) {
                        _this.savingFlag = false;
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
                else {
                    this.jobMatchService.sendAssessment(this.assessmentType, assessmentDataForSave, function (data) {
                        _this.savingFlag = false;
                        if (!_.isUndefined(_this.saveCallback)) {
                            _this.saveCallback();
                        }
                    }, function (error) {
                        _this.savingFlag = false;
                        if (_this.$rootScope.isOnline) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }
            }
            else {
                assessmentDataForSave.testType = this.assessmentType;
                this.jobMatchService.resendAssessment(assessmentDataForSave, function (data) {
                    _this.savingFlag = false;
                    if (!_.isUndefined(_this.saveCallback)) {
                        _this.saveCallback();
                    }
                }, function (error) {
                    _this.savingFlag = false;
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
        }
    };
    SendAssessmentController.prototype.getCandidateJobMatchCardInfo = function (jobMatchId, successCallback) {
        var _this = this;
        this.jobMatchService.getCandidateJobMatchCard(jobMatchId, this.companyId, function (data) {
            angular.merge(_this.candidateJobMatch, data);
            _this.candidateJobMatch = _this._massageCandidateJobMatchData(_this.candidateJobMatch);
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SendAssessmentController.prototype._massageCandidateJobMatchData = function (candidateJobMatch) {
        candidateJobMatch.name = candidateJobMatch.firstName + ' ' + candidateJobMatch.lastName;
        if (candidateJobMatch.jobMatchRequisitionNum == null) {
            candidateJobMatch.jobMatchRequisitionNum = '-';
        }
        this.assessmentName = this.assessmentType == 'Technical' ? candidateJobMatch.techAssessmentName : candidateJobMatch.valueAssessmentName;
        return candidateJobMatch;
    };
    SendAssessmentController.prototype.getAccessTimePreferences = function (successCallback) {
        var _this = this;
        this.jobService.getAssessmentAccessTime(this.candidateJobMatch.jobMatchJobId, this.sendAssessmentLicensePreferenceEnum, function (data) {
            _this.accessTimePreferences = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SendAssessmentController.prototype.accessTimeTypeChanged = function () {
        // make sure the latest time is shown in the chosen access time option according to the chosen time zone.
        this.timeZoneChanged();
    };
    SendAssessmentController.prototype.reminderChanged = function () {
        if (this.isReminderEnabled && this.assessmentData.reminder == 0) {
            this.assessmentData.reminder = 1;
        }
        if (this.assessmentData.accessTime == 'timeBound' || this.assessmentData.accessTime == 'slotWise') {
            var currentStartDateTime = void 0;
            var momentOfCurrentStartDateTime = void 0;
            var currentEndDateTime = void 0;
            var momentOfCurrentEndDateTime = void 0;
            if (this.assessmentData.accessTime == 'timeBound') {
                currentStartDateTime = new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime);
                momentOfCurrentStartDateTime = this.moment(currentStartDateTime);
                currentEndDateTime = new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime);
                momentOfCurrentEndDateTime = this.moment(currentEndDateTime);
            }
            else {
                momentOfCurrentStartDateTime = this.moment(new Date(this.slotWiseStartDate));
                momentOfCurrentEndDateTime = this.moment(new Date(this.slotWiseEndDate));
            }
            var differenceInDays = momentOfCurrentEndDateTime.diff(momentOfCurrentStartDateTime, 'days', true);
            if (this.assessmentData.reminder >= differenceInDays && this.isReminderEnabled) {
                this.reminderErrorFlag = true;
            }
            else {
                this.reminderErrorFlag = false;
            }
        }
    };
    SendAssessmentController.prototype.timeZoneChanged = function () {
        if (this.assessmentData.accessTime == 'timeBound') {
            var currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            var currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            var momentOfCurrentDate = this.moment(currentDate);
            var remainderWithClosestQuarter = momentOfCurrentDate.minute() % 15;
            var momentOfCurrentDateTimeFlooredToClosetQuarter = this.moment(momentOfCurrentDate).subtract(remainderWithClosestQuarter, 'm');
            var momentOfDefaultEndDateTime = this.moment(momentOfCurrentDateTimeFlooredToClosetQuarter).add(this.accessTimePreferences.timeToComplete, 'd');
            $("#timeBoundStartDate").datepicker("setDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
            $("#timeBoundStartDate").datepicker("setStartDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
            $("#timeBoundStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
            $("#timeBoundEndDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            // allowed start date on the calendar of end date should still be the same as start date.
            $("#timeBoundEndDate").datepicker("setStartDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
            $("#timeBoundEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            $("#timeBoundStartTime").timepicker("setTime", this._getTimeStringInAMPMFormat(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
            $('#timeBoundEndTime').timepicker("setTime", "11:59 PM");
            // trigger a reminder change to check if remind after days is in bound
            this.reminderChanged();
        }
        else if (this.assessmentData.accessTime == 'slotWise') {
            var currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            var currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            var momentOfDefaultEndDateTime = this.moment(currentDate).add(this.accessTimePreferences.timeToComplete, 'd');
            $("#slotWiseStartDate").datepicker("setDate", currentDate);
            $("#slotWiseStartDate").datepicker("setStartDate", currentDate);
            $("#slotWiseStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDate));
            $("#slotWiseEndDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            // allowed start date on the calendar of end date should still be the same as start date.
            $("#slotWiseEndDate").datepicker("setStartDate", currentDate);
            $("#slotWiseEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            $("#slotWiseStartTime").timepicker("setTime", "09:00 AM");
            $('#slotWiseEndTime').timepicker("setTime", "12:00 PM");
            // trigger a reminder change to check if remind after days is in bound
            this.reminderChanged();
        }
    };
    SendAssessmentController.prototype._initializeDateAndTimePickersForTimeBound = function () {
        var _this = this;
        $(document).ready(function () {
            var currentDateTimeStringInSelectedTimeZone = _this.moment().tz(_this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            var currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            var momentOfCurrentDate = _this.moment(currentDate);
            var remainderWithClosestQuarter = momentOfCurrentDate.minute() % 15;
            var momentOfCurrentDateTimeFlooredToClosetQuarter = _this.moment(momentOfCurrentDate).subtract(remainderWithClosestQuarter, 'm');
            var momentOfDefaultEndDateTime = _this.moment(momentOfCurrentDateTimeFlooredToClosetQuarter).add(_this.accessTimePreferences.timeToComplete, 'd');
            $('#timeBoundStartDate').datepicker({
                format: "M d, yyyy",
                startDate: momentOfCurrentDateTimeFlooredToClosetQuarter.toDate(),
                weekStart: 1,
                autoclose: true
            });
            // set current date as default value
            $("#timeBoundStartDate").datepicker("setDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
            $("#timeBoundStartDate").datepicker("update", _this.$filter('fourdotfiveDateFormat')(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
            $('#timeBoundEndDate').datepicker({
                format: "M d, yyyy",
                startDate: momentOfCurrentDateTimeFlooredToClosetQuarter.toDate(),
                weekStart: 1,
                autoclose: true
            });
            $("#timeBoundEndDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            $("#timeBoundEndDate").datepicker("update", _this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            $('#timeBoundStartTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: _this._getTimeStringInAMPMFormat(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate())
            });
            $('#timeBoundEndTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '11:59 PM'
            });
            $('#timeBoundStartDate').datepicker().on('changeDate', function (e) {
                _this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
                _this.$timeout(function () {
                    // trigger a reminder change to check if remind after days is in bound
                    _this.reminderChanged();
                }, 100);
            });
            $('#timeBoundEndDate').datepicker().on('changeDate', function (e) {
                _this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
                _this.$timeout(function () {
                    // trigger a reminder change to check if remind after days is in bound
                    _this.reminderChanged();
                }, 100);
            });
            $('#timeBoundStartTime').timepicker().on('changeTime.timepicker', function (e) {
                _this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
                _this.$timeout(function () {
                    // trigger a reminder change to check if remind after days is in bound
                    _this.reminderChanged();
                }, 100);
            });
            $('#timeBoundEndTime').timepicker().on('changeTime.timepicker', function (e) {
                _this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
                _this.$timeout(function () {
                    // trigger a reminder change to check if remind after days is in bound
                    _this.reminderChanged();
                }, 100);
            });
        });
    };
    SendAssessmentController.prototype._initializeDateAndTimePickersForSlotWise = function () {
        var _this = this;
        $(document).ready(function () {
            var currentDateTimeStringInSelectedTimeZone = _this.moment().tz(_this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            var currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            var momentOfDefaultEndDateTime = _this.moment(currentDate).add(_this.accessTimePreferences.timeToComplete, 'd');
            $('#slotWiseStartDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDate,
                weekStart: 1,
                autoclose: true
            });
            // set current date as default value
            $("#slotWiseStartDate").datepicker("setDate", currentDate);
            $("#slotWiseStartDate").datepicker("update", _this.$filter('fourdotfiveDateFormat')(currentDate));
            $('#slotWiseEndDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDate,
                weekStart: 1,
                autoclose: true
            });
            $("#slotWiseEndDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            $("#slotWiseEndDate").datepicker("update", _this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            $('#slotWiseStartTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '09:00 AM'
            });
            $('#slotWiseEndTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '12:00 PM'
            });
            $('#slotWiseStartDate').datepicker().on('changeDate', function (e) {
                _this._validateAndCorrectStartDateAndEndDateForSlotWise();
                _this.$timeout(function () {
                    // trigger a reminder change to check if remind after days is in bound
                    _this.reminderChanged();
                }, 100);
            });
            $('#slotWiseEndDate').datepicker().on('changeDate', function (e) {
                _this._validateAndCorrectStartDateAndEndDateForSlotWise();
                _this.$timeout(function () {
                    // trigger a reminder change to check if remind after days is in bound
                    _this.reminderChanged();
                }, 100);
            });
            $('#slotWiseStartTime').timepicker().on('changeTime.timepicker', function (e) {
                _this._validateAndCorrectStartTimeAndEndTimeForSlotWise();
            });
            $('#slotWiseEndTime').timepicker().on('changeTime.timepicker', function (e) {
                _this._validateAndCorrectStartTimeAndEndTimeForSlotWise();
            });
        });
    };
    SendAssessmentController.prototype._getTimeStringInAMPMFormat = function (date) {
        return this.moment(date).format("hh:mm A");
    };
    SendAssessmentController.prototype._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound = function () {
        var currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
        var momentOfCurrentDateTime = this.moment(currentDateTimeStringInSelectedTimeZone);
        var currentStartDateTime = new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime);
        var momentOfCurrentStartDateTime = this.moment(currentStartDateTime);
        var currentEndDateTime = new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime);
        // if the start date is same as the current date
        var startDateAndCurrentDateAreSameFlag = momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'day');
        // if the start hours are less than current hours
        var startHoursLessThanCurrentHoursFlag = momentOfCurrentStartDateTime.isBefore(momentOfCurrentDateTime, 'hour');
        var remainderWithClosestQuarter = momentOfCurrentDateTime.minute() % 15;
        var currentDateTimeFlooredToClosetQuarter = momentOfCurrentDateTime.subtract(remainderWithClosestQuarter, 'm').toDate();
        // if the hours are equal but minutes are less than current date time floored to closest quarter minutes.
        var hoursEqualButStartMinutesLessThanCurrentMinutesFlag = (momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'hour') && momentOfCurrentStartDateTime.isBefore(currentDateTimeFlooredToClosetQuarter, 'minute'));
        if (startDateAndCurrentDateAreSameFlag && (startHoursLessThanCurrentHoursFlag || hoursEqualButStartMinutesLessThanCurrentMinutesFlag)) {
            $("#timeBoundStartTime").timepicker("setTime", this._getTimeStringInAMPMFormat(currentDateTimeFlooredToClosetQuarter));
        }
        else if (currentStartDateTime >= currentEndDateTime) {
            // after the change to 'start time', check if the existing 'end time' component keeps 'end date time' as greater than 'start date time'
            // if not, make the 'end date time' as 'time to complete' days greater than currentStartDateTime
            var defaultEndDateTime = this.moment(currentStartDateTime).add(this.accessTimePreferences.timeToComplete, 'd').toDate();
            $("#timeBoundEndDate").datepicker("setDate", defaultEndDateTime);
            $("#timeBoundEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(defaultEndDateTime));
            $('#timeBoundEndTime').timepicker("setTime", '11:59 PM');
        }
        // set start date of end date calendar to be current start date
        $("#timeBoundEndDate").datepicker("setStartDate", currentStartDateTime);
    };
    SendAssessmentController.prototype._validateAndCorrectStartDateAndEndDateForSlotWise = function () {
        var momentOfCurrentStartDate = this.moment(new Date(this.slotWiseStartDate));
        var momentOfCurrentEndDate = this.moment(new Date(this.slotWiseEndDate));
        if (momentOfCurrentEndDate.isBefore(momentOfCurrentStartDate, 'day')) {
            // make the 'end date' as 'time to complete' days greater than 'start date'
            var defaultEndDate = momentOfCurrentStartDate.add(this.accessTimePreferences.timeToComplete, 'd').toDate();
            $("#slotWiseEndDate").datepicker("setDate", defaultEndDate);
            $("#slotWiseEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(defaultEndDate));
        }
        // set start date of end date calendar to be current start date
        $("#slotWiseEndDate").datepicker("setStartDate", momentOfCurrentStartDate.toDate());
    };
    SendAssessmentController.prototype._validateAndCorrectStartTimeAndEndTimeForSlotWise = function () {
        // use start date for the date part. Otherwise we can't parse date.
        var momentOfCurrentStartTime = this.moment(new Date(this.slotWiseStartDate + " " + this.slotWiseStartTime));
        var momentOfCurrentEndTime = this.moment(new Date(this.slotWiseStartDate + " " + this.slotWiseEndTime));
        if (momentOfCurrentEndTime.isBefore(momentOfCurrentStartTime)) {
            // make the 'end time' as 1 hour greater than 'start time'
            var defaultEndTime = momentOfCurrentStartTime.add(1, 'h').toDate();
            $('#slotWiseEndTime').timepicker("setTime", this._getTimeStringInAMPMFormat(defaultEndTime));
        }
    };
    SendAssessmentController.prototype.onInternalNoteChanged = function () {
        this.assessmentData.externalNote = this.assessmentData.notes;
    };
    SendAssessmentController.prototype.onExternalNoteChange = function (event) {
        this.assessmentData.externalNote = event.externalNote;
    };
    SendAssessmentController.prototype.onCopyNoteChange = function (event) {
        this.copyNote = event.copyNote;
    };
    SendAssessmentController.prototype.receiveFormalizedComment = function (event) {
        this.assessmentData.notes = event;
        this.onInternalNoteChanged();
    };
    SendAssessmentController.prototype.onVoiceTranscript = function (transcript) {
        if (this.assessmentData.notes) {
            this.assessmentData.notes += ' ' + transcript;
        }
        else {
            this.assessmentData.notes = transcript;
        }
        this.onInternalNoteChanged();
    };
    SendAssessmentController.prototype.reminderEnabledOrDisabled = function () {
        if (!this.isReminderEnabled) {
            this.assessmentData.reminder = 0;
            this.reminderErrorFlag = false;
        }
        else {
            this.assessmentData.reminder = this.defaultReminderInterval;
            this.reminderChanged();
        }
    };
    return SendAssessmentController;
}());
SendAssessmentController.$inject = ['$rootScope', '$uibModal', '$timeout', '$filter', 'moment', 'dateTimeUtilityService', 'jobMatchService', 'jobService', 'assessmentService', 'planService', 'candidateService', 'companyService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './send-assessment.html;
import * as TEMPLATE from 'raw-loader!./send-assessment.html';
export var SendAssessmentComponent = {
    selector: 'sendAssessment',
    component: {
        bindings: {
            jobMatchId: '@',
            jobMatchDetailsArrayString: '@',
            candidateId: '@',
            assessmentType: '@',
            assessmentSendMode: '@',
            notes: '@',
            corporateId: '@',
            corporateName: '@',
            buName: '@',
            isSharedRequisition: '<',
            saveCallback: '&',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: SendAssessmentController,
        // templateUrl: 'app/shared/jobMatchActions/sendAssessment/send-assessment.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=send-assessment.component.js.map